import Slider from "react-slick";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {Helmet} from 'react-helmet';
import Faqs from "../Page/Faqs";
import Newsletter from "../Page/Newsletter";
import PopularHotels from "../Page/Hotels/Component/PopularHotels";
import PopularFlights from "../Page/PopularFlights";
import FlightsWidgit from "../Page/FlightsWidgit";
import Badge from "../Page/Badge";


function App1() {
  return (
   <>
    <Helmet>     
  <title>Privacy Policy, Lowest Airfare and offers | cheapflightsprices.com</title>
  <meta name="description" content="Find Cheap Flight Tickets at cheapflightsprices.com. Also Get best deals online for your summer vacation. Book your flight tickets in advance to avail the best discounts. Hurry up! Offer is valid for limited time"/>
  <meta name="keywords" content="Cheapflightsprices, Cheap Flights Prices,cheap flight booking, cheap flight fares,flight booking offer,Cheap Flights Prices,cheapest ticket booking" />
<meta property="og:description" content="Find Cheap Flight Tickets at cheapflightsprices.com. Also Get best deals online for your summer vacation. Book your flight tickets in advance to avail the best discounts. Hurry up! Offer is valid for limited time" />
<meta property="og:site_name" content="Cheap Flights Prices, Lowest Airfare and offers | cheapflightsprices.com" />
<meta name="twitter:title" content="Cheap Flights Prices, Lowest Airfare and offers | cheapflightsprices.com" />
<meta name="twitter:description" content="Find Cheap Flight Tickets at cheapflightsprices.com. Also Get best deals online for your summer vacation. Book your flight tickets in advance to avail the best discounts. Hurry up! Offer is valid for limited time" />
<meta name="Distribution" content="Global" />
<meta name="Robots" content="follow, index, all" />
<meta name="googlebot" content="index, follow" />
<meta http-equiv="Expires" content="never" />
<meta name="document-type" content="public" />
<meta name="revisit-after" content="daily" />
<meta name="country" content="India" />
<meta name="Language" content="English" />
<meta name='rating' content="general" />
<meta name="author" content="cheapflightsprices.com" />
<link rel="canonical" href="https://cheapflightsprices.com/privacy-policy.html" />
  </Helmet>
   <section id="banner_section" className="innerbannersection">
    <div className="hero-container" data-aos="zoom-in" data-aos-delay="100">
      <h1 className="mb-2 pb-0">Cheap Flights</h1>
      <h2>Cheap Flights Prices Booking Start @ $24</h2>
      <FlightsWidgit/>
    </div>
  </section>
<Badge/>
 

    <main id="main">
    <section id="mainsection" className="section-with-bg">
      <div className="container" data-aos="fade-up">
  <div className="section-header">
    <h2><strong>Privacy Policy</strong></h2>
  </div>
  <div className="designcontainer">

    <p>
      We value your privacy. This website <strong>(cheapflightsprices.com)</strong> operates as a travel search and booking facilitation service through trusted third-party partners. 
      Please read this Privacy Policy carefully to understand how your information may be handled.
    </p>

    <h3>1. Information Collection</h3>
    <p>
      We do not directly collect personal information such as your name, payment details, or passport details. 
      Any booking information you provide is collected and processed by our affiliate partners (the actual booking providers). 
      Please review the privacy policies of our partners before completing any booking.
    </p>

    <h3>2. Use of Information</h3>
    <p>
      - We may use non-personal information such as cookies, analytics, and aggregated traffic data to improve user experience.<br/>
      - Booking data and payments are handled exclusively by the partner website where the booking is made.<br/>
      - We are not responsible for the storage, security, or usage of information submitted on third-party booking platforms.
    </p>

    <h3>3. Third-Party Links</h3>
    <p>
      Our website displays flight search results and booking options from external providers. 
      When you click and complete a booking, you are redirected to a partner’s website. 
      Their policies regarding data usage, refunds, and cancellations will apply.
    </p>

    <h3>4. Affiliate Disclosure</h3>
    <p>
      We participate in affiliate programs. This means we may earn a commission when you book a flight through our partner links. 
      However, this does not affect the price you pay and does not make us the seller of travel services.
    </p>

    <h3>5. Limitation of Liability</h3>
    <p>
      While we strive to provide accurate information, we cannot guarantee completeness, availability, or accuracy of flight data, prices, or booking terms. 
      All contracts, refunds, and disputes remain strictly between you and the third-party provider.
    </p>

    <h3>6. Policy Updates</h3>
    <p>
      We may update this Privacy Policy from time to time. Any changes will be effective immediately upon posting. 
      Continued use of our website means you accept the updated policy.
    </p>

  </div>
</div>

    </section>
    <PopularFlights/>
        <PopularHotels />
    <Faqs/>
    <Newsletter/>
      </main>
    </>
  );
}
export default App1;
